angular
    .module('app')
    .component('campaignsEdit', {
        templateUrl: '/templates/pages/campaigns/campaignsEdit/campaignsEdit.html',
        controller: 'CampaignEditController',
        controllerAs: 'vm',
    });